"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseTimeUnits = exports.TIME_UNITS_PATTERN = exports.parseYear = exports.YEAR_PATTERN = exports.parseOrdinalNumberPattern = exports.ORDINAL_NUMBER_PATTERN = exports.parseNumberPattern = exports.NUMBER_PATTERN = exports.TIME_UNIT_DICTIONARY = exports.ORDINAL_WORD_DICTIONARY = exports.INTEGER_WORD_DICTIONARY = exports.MONTH_DICTIONARY = exports.FULL_MONTH_NAME_DICTIONARY = exports.WEEKDAY_DICTIONARY = void 0;
const pattern_1 = require("../../utils/pattern");
const years_1 = require("../../calculation/years");
exports.WEEKDAY_DICTIONARY = {
    'κυριακή': 0,
    'κυριακη': 0,
    'κυριακής': 0,
    'κυριακης': 0,  
    'δευτέρα': 1,
    'δευτερα': 1,
    'δευτέρας': 1,
    'δευτερας': 1,
    'τρίτη': 2,
    'τριτη':2,
    'τρίτης':2,
    'τριτης':2,
    'τετάρτη': 3,
    'τεταρτη': 3,
    'τετάρτης': 3,
    'τεταρτης': 3,
    'πέμπτη': 4,
    'πεμπτη': 4,
    'πέμπτης': 4,
    'πεμπτης': 4,
    'παρασκευή': 5,
    'παρασκευη': 5,
    'παρασκευής': 5,
    'παρασκευης': 5,
    'σάββατο': 6,
    'σαββατο': 6,
    'σαββάτου': 6,
    'σαββατου': 6,
};

exports.FULL_MONTH_NAME_DICTIONARY = {
    'ιανουάριος': 1,
    'ιανουαριος': 1,
    'ιανουαρίου': 1,
    'ιανουαριου': 1,
    'ιανουάριο': 1,
    'ιανουαριο': 1,
    'φεβρουάριος': 2,
    'φεβρουαριος': 2,
    'φεβρουαρίου': 2,
    'φεβρουαριου': 2,
    'φεβρουάριο': 2,
    'φεβρουαριο': 2,
    'μάρτιος': 3,
    'μαρτιος': 3,
    'μαρτίου': 3,
    'μαρτιου': 3,
    'μάρτιο': 3,
    'μαρτιο': 3,
    'απρίλιος': 4,
    'απριλιος': 4,
    'απριλίου': 4,
    'απριλιου': 4,
    'απρίλιο': 4,
    'απριλιο': 4,
    'μάιος': 5,
    'μαιος': 5,
    'μαΐου': 5,
    'μαίου': 5,
    'μαιου': 5,
    'μάιο': 5,
    'μαιο': 5,
    'ιούνιος': 6,
    'ιουνιος': 6,
    'ιουνίου': 6,
    'ιουνιου': 6,
    'ιούνιο': 6,
    'ιουνιο': 6,
    'ιούλιος': 7,
    'ιουλιος': 7,
    'ιουλίου': 7,
    'ιουλιου': 7,
    'ιούλιο': 7,
    'ιουλιο': 7,
    'αύγουστος': 8,
    'αυγουστος': 8,
    'αυγούστου': 8,
    'αυγουστου': 8,
    'αύγουστο': 8,
    'αυγουστο': 8,
    'σεπτέμβριος': 9,
    'σεπτεμβριος': 9,
    'σεπτεμβρίου': 9,
    'σεπτεμβριου': 9,
    'σεπτέμβριο': 9,
    'σεπτεμβριο': 9,
    'οκτώβριος': 10,
    'οκτωβριος': 10,
    'οκτωβρίου': 10,
    'οκτωβριου': 10,
    'οκτώβριο': 10,
    'οκτωβριο': 10,
    'νοέμβριος': 11,
    'νοεμβριος': 11,
    'νοεμβρίου': 11,
    'νοεμβριου': 11,
    'νοέμβριο': 11,
    'νοεμβριο': 11,
    'δεκέμβριος': 12,
    'δεκεμβριος': 12,
    'δεκεμβρίου': 12,
    'δεκεμβριου': 12,
    'δεκέμβριο': 12,
    'δεκεμβριο': 12,
};
exports.MONTH_DICTIONARY = Object.assign(Object.assign({}, exports.FULL_MONTH_NAME_DICTIONARY), { jan: 1, "jan.": 1, feb: 2, "feb.": 2, mar: 3, "mar.": 3, apr: 4, "apr.": 4, jun: 6, "jun.": 6, jul: 7, "jul.": 7, aug: 8, "aug.": 8, sep: 9, "sep.": 9, sept: 9, "sept.": 9, oct: 10, "oct.": 10, nov: 11, "nov.": 11, dec: 12, "dec.": 12 });
exports.INTEGER_WORD_DICTIONARY = {
    'ένας': 1,
    'ενας': 1,
    'ενός': 1,
    'ενος': 1,
    'μία': 1,
    'μια': 1,
    'ένα': 1,
    'ενα': 1,
    'δύο': 2,
    'δυο': 2,
    'τρείς': 3,
    'τρεις': 3,
    'τριών': 3,
    'τριων': 3,
    'τέσσερις': 4,
    'τεσσερις': 4,
    'τεσσάρων': 4,
    'τεσσαρων': 4,
    'πέντε': 5,
    'πεντε': 5,
    'έξι': 6,
    'εξι': 6,
    'επτά': 7,
    'επτα': 7,
    'εφτά': 7,
    'εφτα': 7,
    'οκτώ': 8,
    'οκτω': 8,
    'εννιά': 9,
    'εννια': 9,
    'δέκα': 10,
    'δεκα': 10,
    'ένδεκα': 11,
    'ενδεκα': 11,
    'έντεκα': 11,
    'εντεκα': 11,
    'δώδεκα': 12,
    'δωδεκα': 12,
};
exports.ORDINAL_WORD_DICTIONARY = {
    'πρώτος': 1,
    'πρωτος': 1,
    'πρώτου': 1,
    'πρωτου': 1,
    'πρώτο': 1,
    'πρωτο': 1,
    'πρώτη': 1,
    'πρωτη': 1,
    'πρώτης': 1,
    'πρωτης': 1,
    'δεύτερος': 2,
    'δευτερος': 2,
    'δεύτερου': 2,
    'δευτερου': 2,
    'δεύτερο': 2,
    'δευτερο': 2,
    'δεύτερη': 2,
    'δευτερη': 2,
    'δεύτερης': 2,
    'δευτερης': 2,
    'τρίτος': 3,
    'τριτος': 3,
    'τρίτου': 3,
    'τριτου': 3,
    'τρίτο': 3,
    'τριτο': 3,
    'τρίτη': 3,
    'τριτη': 3,
    'τρίτης': 3,
    'τριτης': 3,
    'τέταρτος': 4,
    'τεταρτος': 4,
    'τέταρτου': 4,
    'τεταρτου': 4,
    'τέταρτο': 4,
    'τεταρτο': 4,
    'τέταρτη': 4,
    'τεταρτη': 4,
    'τέταρτης': 4,
    'τεταρτης': 4,
    'πέμπτος': 5,
    'πεμπτος': 5,
    'πέμπτου': 5,
    'πεμπτου': 5,
    'πέμπτο': 5,
    'πεμπτο': 5,
    'πέμπτη': 5,
    'πεμπτη': 5,
    'πέμπτης': 5,
    'πεμπτης': 5,
    'πέμτος': 5,
    'πεμτος': 5,
    'πέμτου': 5,
    'πεμτου': 5,
    'πέμτο': 5,
    'πεμτο': 5,
    'πέμτη': 5,
    'πεμτη': 5,
    'πέμτης': 5,
    'πεμτης': 5,
    'έκτος': 6,
    'εκτος': 6,
    'έκτου': 6,
    'εκτου': 6,
    'έκτο': 6,
    'εκτο': 6,
    'έκτη': 6,
    'εκτη': 6,
    'έκτης': 6,
    'εκτης': 6,
    'έβδομος': 7,
    'εβδομος': 7,
    'έβδομου': 7,
    'εβδομου': 7,
    'έβδομο': 7,
    'εβδομο': 7,
    'έβδομη': 7,
    'εβδομη': 7,
    'έβδομης': 7,
    'εβδομης': 7,
    'όγδοος': 8,
    'ογδοος': 8,
    'όγδοου': 8,
    'ογδοου': 8,
    'όγδοο': 8,
    'ογδοο': 8,
    'όγδοη': 8,
    'ογδοη': 8,
    'όγδοης': 8,
    'ογδοης': 8,
    'ένατος': 9,
    'ενατος': 9,
    'ένατου': 9,
    'ενατου': 9,
    'ένατο': 9,
    'ενατο': 9,
    'ένατη': 9,
    'ενατη': 9,
    'ένατης': 9,
    'ενατης': 9,
    'δέκατος': 10,
    'δεκατος': 10,
    'δέκατου': 10,
    'δεκατου': 10,
    'δέκατο': 10,
    'δεκατο': 10,
    'δέκατη': 10,
    'δεκατη': 10,
    'δέκατης': 10,
    'δεκατης': 10,
    'ενδέκατος': 11,
    'ενδεκατος': 11,
    'ενδέκατου': 11,
    'ενδεκατου': 11,
    'ενδέκατο': 11,
    'ενδεκατο': 11,
    'ενδέκατη': 11,
    'ενδεκατη': 11,
    'ενδέκατης': 11,
    'ενδεκατης': 11,
    'δωδέκατος': 12,
    'δωδεκατος': 12,
    'δωδέκατου': 12,
    'δωδεκατου': 12,
    'δωδέκατο': 12,
    'δωδεκατο': 12,
    'δωδέκατη': 12,
    'δωδεκατη': 12,
    'δωδέκατης': 12,
    'δωδεκατης': 12,
    'δέκατος τρίτος': 13,
    'δεκατος τριτος': 13,
    'δέκατου τρίτου': 13,
    'δεκατου τριτου': 13,
    'δέκατο τρίτο': 13,
    'δεκατο τριτο': 13,
    'δέκατη τρίτη': 13,
    'δεκατη τριτη': 13,
    'δέκατης τρίτης': 13,
    'δεκατης τριτης': 13,
    'δέκατος τέταρτος': 14,
    'δεκατος τεταρτος': 14,
    'δέκατου τέταρτου': 14,
    'δεκατου τεταρτου': 14,
    'δέκατο τέταρτο': 14,
    'δεκατο τεταρτο': 14,
    'δέκατη τέταρτη': 14,
    'δεκατη τεταρτη': 14,
    'δέκατης τέταρτης': 14,
    'δεκατης τεταρτης': 14,
    'δέκατος πέμπτος': 15,
    'δεκατος πεμπτος': 15,
    'δέκατου πέμπτου': 15,
    'δεκατου πεμπτου': 15,
    'δέκατο πέμπτο': 15,
    'δεκατο πεμπτο': 15,
    'δέκατη πέμπτη': 15,
    'δεκατη πεμπτη': 15,
    'δέκατης πέμπτης': 15,
    'δεκατης πεμπτης': 15,
    'δέκατος πέμτος': 15,
    'δεκατος πεμτος': 15,
    'δέκατου πέμτου': 15,
    'δεκατου πεμτου': 15,
    'δέκατο πέμτο': 15,
    'δεκατο πεμτο': 15,
    'δέκατη πέμτη': 15,
    'δεκατη πεμτη': 15,
    'δέκατης πέμτης': 15,
    'δεκατης πεμτης': 15,
    'δέκατος έκτος': 16,
    'δεκατος εκτος': 16,
    'δέκατου έκτου': 16,
    'δεκατου εκτου': 16,
    'δέκατο έκτο': 16,
    'δεκατο εκτο': 16,
    'δέκατη έκτη': 16,
    'δεκατη εκτη': 16,
    'δέκατης έκτης': 16,
    'δεκατης εκτης': 16,
    'δέκατος έβδομος': 17,
    'δεκατος εβδομος': 17,
    'δέκατου έβδομου': 17,
    'δεκατου εβδομου': 17,
    'δέκατο έβδομο': 17,
    'δεκατο εβδομο': 17,
    'δέκατη έβδομη': 17,
    'δεκατη εβδομη': 17,
    'δέκατης έβδομης': 17,
    'δεκατης εβδομης': 17,
    'δέκατος όγδοος': 18,
    'δεκατος ογδοος': 18,
    'δέκατου όγδοου': 18,
    'δεκατου ογδοου': 18,
    'δέκατο όγδοο': 18,
    'δεκατο ογδοο': 18,
    'δέκατη όγδοη': 18,
    'δεκατη ογδοη': 18,
    'δέκατης όγδοης': 18,
    'δεκατης ογδοης': 18,
    'δέκατος ένατος': 19,
    'δεκατος ενατος': 19,
    'δέκατου ένατου': 19,
    'δεκατου ενατου': 19,
    'δέκατο ένατο': 19,
    'δεκατο ενατο': 19,
    'δέκατη ένατη': 19,
    'δεκατη ενατη': 19,
    'δέκατης ένατης': 19,
    'δεκατης ενατης': 19,
    'εικοστός':20,
    'εικοστος':20,
    'εικοστού':20,
    'εικοστου':20,
    'εικοστό':20,
    'εικοστο':20,
    'εικοστή':20,
    'εικοστη':20,
    'εικοστής':20,
    'εικοστης':20,
    'εικοστός πρώτος':21,
    'εικοστος πρωτος':21,
    'εικοστού πρώτου':21,
    'εικοστου πρωτου':21,
    'εικοστό πρώτο':21,
    'εικοστο πρωτο':21,
    'εικοστή πρώτη':21,
    'εικοστη πρωτη':21,
    'εικοστής πρώτης':21,
    'εικοστης πρωτης':21,
    'εικοστός δεύτερος':22,
    'εικοστος δευτερος':22,
    'εικοστού δεύτερου':22,
    'εικοστου δευτερου':22,
    'εικοστό δεύτερο':22,
    'εικοστο δευτερο':22,
    'εικοστή δεύτερη':22,
    'εικοστη δευτερη':22,
    'εικοστής δεύτερης':22,
    'εικοστης δευτερης':22,
    'εικοστός τρίτος':23,
    'εικοστος τριτος':23,
    'εικοστού τρίτου':23,
    'εικοστου τριτου':23,
    'εικοστό τρίτο':23,
    'εικοστο τριτο':23,
    'εικοστή τρίτη':23,
    'εικοστη τριτη':23,
    'εικοστής τρίτης':23,
    'εικοστης τριτης':23,
    'εικοστός τέταρτος':24,
    'εικοστος τεταρτος':24,
    'εικοστού τέταρτου':24,
    'εικοστου τεταρτου':24,
    'εικοστό τέταρτο':24,
    'εικοστο τεταρτο':24,
    'εικοστή τέταρτη':24,
    'εικοστη τεταρτη':24,
    'εικοστής τέταρτης':24,
    'εικοστης τεταρτης':24,
    'εικοστός πέμπτος':25,
    'εικοστος πεμπτος':25,
    'εικοστού πέμπτου':25,
    'εικοστου πεμπτου':25,
    'εικοστό πέμπτο':25,
    'εικοστο πεμπτο':25,
    'εικοστή πέμπτη':25,
    'εικοστη πεμπτη':25,
    'εικοστής πέμπτης':25,
    'εικοστης πεμπτης':25,
    'εικοστός πέμτος':25,
    'εικοστος πεμτος':25,
    'εικοστού πέμτου':25,
    'εικοστου πεμτου':25,
    'εικοστό πέμτο':25,
    'εικοστο πεμτο':25,
    'εικοστή πέμτη':25,
    'εικοστη πεμτη':25,
    'εικοστής πέμτης':25,
    'εικοστης πεμτης':25,
    'εικοστός έκτος':26,
    'εικοστος εκτος':26,
    'εικοστού έκτου':26,
    'εικοστου εκτου':26,
    'εικοστό έκτο':26,
    'εικοστο εκτο':26,
    'εικοστή έκτη':26,
    'εικοστη εκτη':26,
    'εικοστής έκτης':26,
    'εικοστης εκτης':26,
    'εικοστός έβδομος':27,
    'εικοστος εβδομος':27,
    'εικοστού έβδομου':27,
    'εικοστου εβδομου':27,
    'εικοστό έβδομο':27,
    'εικοστο εβδομο':27,
    'εικοστή έβδομη':27,
    'εικοστη εβδομη':27,
    'εικοστής έβδομης':27,
    'εικοστης εβδομης':27,
    'εικοστός όγδοος':28,
    'εικοστος ογδοος':28,
    'εικοστού όγδοου':28,
    'εικοστου ογδοου':28,
    'εικοστό όγδοο':28,
    'εικοστο ογδοο':28,
    'εικοστή όγδοη':28,
    'εικοστη ογδοη':28,
    'εικοστής όγδοης':28,
    'εικοστης ογδοης':28,
    'εικοστός ένατος':29,
    'εικοστος ενατος':29,
    'εικοστού ένατου':29,
    'εικοστου ενατου':29,
    'εικοστό ένατο':29,
    'εικοστο ενατο':29,
    'εικοστή ένατη':29,
    'εικοστη ενατη':29,
    'εικοστής ένατης':29,
    'εικοστης ενατης':29,
    'τριακοστός':30,
    'τριακοστος':30,
    'τριακοστού':30,
    'τριακοστου':30,
    'τριακοστό':30,
    'τριακοστο':30,
    'τριακοστή':30,
    'τριακοστη':30,
    'τριακοστής':30,
    'τριακοστης':30,
    'τριακοστός πρώτος':31,
    'τριακοστος πρωτος':31,
    'τριακοστού πρώτου':31,
    'τριακοστου πρωτου':31,
    'τριακοστό πρώτο':31,
    'τριακοστο πρωτο':31,
    'τριακοστή πρώτη':31,
    'τριακοστη πρωτη':31,
    'τριακοστής πρώτης':31,
    'τριακοστης πρωτης':31,
};
exports.TIME_UNIT_DICTIONARY = {
    'δεύτερο': "second",
    'δευτερο': "second",
    'δεύτερου': "second",
    'δευτερου': "second",
    'δεύτερα': "second",
    'δευτερα': "second",
    'δεύτερων': "second",
    'δευτερων': "second",
    'δευτερόλεπτο': "second",
    'δευτερολεπτο': "second",
    'δευτερόλεπτου': "second",
    'δευτερολεπτου': "second",
    'δευτερόλεπτα': "second",
    'δευτερολεπτα': "second",
    'δευτερολέπτων': "second",
    'δευτερολεπτων': "second",
    'λεπτό': "minute",
    'λεπτο': "minute",
    'λεπτού': "minute",
    'λεπτου': "minute",
    'λεπτά': "minute",
    'λεπτα': "minute",
    'λεπτών': "minute",
    'λεπτων': "minute",
    'ώρα': "hour",
    'ωρα': "hour",
    'ώρας': "hour",
    'ωρας': "hour",
    'ώρες': "hour",
    'ωρες': "hour",
    'ωρών': "hour",
    'ωρων': "hour",
    'μέρα': "d",
    'μερα': "d",
    'μέρας': "d",
    'μερας': "d",
    'μέρες': "d",
    'μερες': "d",
    'μερών': "d",
    'μερων': "d",
    'εβδομάδα': "week",
    'εβδομαδα': "week",
    'εβδομάδας': "week",
    'εβδομαδας': "week",
    'εβδομάδες': "week",
    'εβδομαδες': "week",
    'εβδομάδων': "week",
    'εβδομαδων': "week",
    'μήνας': "month",
    'μηνας': "month",
    'μήνα': "month",
    'μηνα': "month",
    'μήνες': "month",
    'μηνες': "month",
    'μηνών': "month",
    'μηνων': "month",
    'έτος': "year",
    'ετος': "year",
    'έτους': "year",
    'ετους': "year",
    'έτη': "year",
    'ετη': "year",
    'ετών': "year",
    'ετων': "year",
    'χρόνος': "year",
    'χρονος': "year",
    'χρόνου': "year",
    'χρονου': "year",
    'χρόνο': "year",
    'χρονο': "year",
    'χρόνια': "year",
    'χρονια': "year",
    'χρόνων': "year",
    'χρονων': "year",
};
exports.NUMBER_PATTERN = `(?:${pattern_1.matchAnyPattern(exports.INTEGER_WORD_DICTIONARY)}|[0-9]+|[0-9]+\\.[0-9]+|μισ[όοήη]|μερικ(?:[ήηάα]|ο[ύυ]ς|[έε]ς)|λ[ίι]γ(?:[ηα]|ους|ες)|αρκετ(?:[ήηάα]|ο[ύυ]ς|[έε]ς))`;
function parseNumberPattern(match) {
    const num = match.toLowerCase();
    if (exports.INTEGER_WORD_DICTIONARY[num] !== undefined) {
        return exports.INTEGER_WORD_DICTIONARY[num];
    }
    else if (num.match(/[έε]νας?|εν[όο]ς|μ[ίι]α/)) {
        return 1;
    }
    else if (num.match(/μερικ(?:[ήηάα]|ο[ύυ]ς|[έε]ς)|λ[ίι]γ(?:[ηα]|ους|ες)/)) {
        return 3;
    }
    else if (num.match(/μισ[όοήη]/)) {
        return 0.5;
    }
    else if (num.match(/αρκετ(?:[ήηάα]|ο[ύυ]ς|[έε]ς)/)) {
        return 7;
    }
    return parseFloat(num);
}
exports.parseNumberPattern = parseNumberPattern;
exports.ORDINAL_NUMBER_PATTERN = `(?:${pattern_1.matchAnyPattern(exports.ORDINAL_WORD_DICTIONARY)}|[0-9]{1,2}η?)`;
function parseOrdinalNumberPattern(match) {
    let num = match.toLowerCase();
    if (exports.ORDINAL_WORD_DICTIONARY[num] !== undefined) {
        return exports.ORDINAL_WORD_DICTIONARY[num];
    }
    num = num.replace(/η$/i, "");
    return parseInt(num);
}
exports.parseOrdinalNumberPattern = parseOrdinalNumberPattern;
exports.YEAR_PATTERN = `(?:[1-9][0-9]{0,3}\\s{0,2}(?:π\\.?Χ\\.?|:μ\\.?Χ\\.?)|[1-2][0-9]{3}|[5-9][0-9])`;
function parseYear(match) {
    if (/π\.?Χ\.?/i.test(match)) {
        match = match.replace(/π\.?Χ\.?/i, "");
        return -parseInt(match);
    }
    if (/μ\.?Χ\.?/i.test(match)) {
        match = match.replace(/μ\.?Χ\.?/i, "");
        return parseInt(match);
    }
    const rawYearNumber = parseInt(match);
    return years_1.findMostLikelyADYear(rawYearNumber);
}
exports.parseYear = parseYear;
const SINGLE_TIME_UNIT_PATTERN = `(${exports.NUMBER_PATTERN})\\s{0,3}(${pattern_1.matchAnyPattern(exports.TIME_UNIT_DICTIONARY)})`;
const SINGLE_TIME_UNIT_REGEX = new RegExp(SINGLE_TIME_UNIT_PATTERN, "i");
exports.TIME_UNITS_PATTERN = pattern_1.repeatedTimeunitPattern(`(?:(?:σχεδ[όο]ν|περ[ίι]που)(?:\\s{0,2}(?:σε|στη|στις))?\\s{0,3})?`, SINGLE_TIME_UNIT_PATTERN);
function parseTimeUnits(timeunitText) {
    const fragments = {};
    let remainingText = timeunitText;
    let match = SINGLE_TIME_UNIT_REGEX.exec(remainingText);
    while (match) {
        collectDateTimeFragment(fragments, match);
        remainingText = remainingText.substring(match[0].length).trim();
        match = SINGLE_TIME_UNIT_REGEX.exec(remainingText);
    }
    return fragments;
}
exports.parseTimeUnits = parseTimeUnits;
function collectDateTimeFragment(fragments, match) {
    const num = parseNumberPattern(match[1]);
    const unit = exports.TIME_UNIT_DICTIONARY[match[2].toLowerCase()];
    fragments[unit] = num;
}
